import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { AddCustomOptionService } from "../../services/add-custom-option.service";
import { OptionsService } from "../../services/options.service";
import { QuoteInfoService } from "../../services/quote-info.service";
import { LoadingSpinnerService } from "../../services/loading-spinner.service";
import { ToasterService, Toast } from "angular2-toaster";
import { HttpResponseService } from '../../services/httpresponse-service';

import { PartCategory } from "../../model/part-category";
import { TextValuePair } from "../../model/constants";
import { SelectedOption } from "../../model/selected-option";
import { Adjustment } from "../../model/adjustment";

@Component({
    selector: 'add-custom-option',
    template: require('./add-custom-option.component.html'),
    styles: [require('./add-custom-option.component.scss')]
})
export class AddCustomOptionComponent implements OnInit, OnDestroy {
    customOption: SelectedOption = new SelectedOption();
    categories: Array<TextValuePair> = [];
    selectedOptions: Array<SelectedOption>;
    customOptions: Array<SelectedOption>; 

    quoteId: number;
    categoryId: number;
    productLineId: number;
    modelId: number;

    enableSave: boolean = false;
    validPrice: boolean = true;
    subscription: Subscription = new Subscription();

    constructor(
        public addCustomOptionService: AddCustomOptionService,
        public optionsService: OptionsService,
        public quoteInfoService: QuoteInfoService,
        public spinnerService: LoadingSpinnerService,
        public toasterService: ToasterService,
        public httpResponseService: HttpResponseService
    ) { }

    ngOnInit() {
        this.getSelectedOptionCategories();
        const categoryIdSub = this.quoteInfoService.categoryId$.subscribe(x => { this.categoryId = x; });
        this.subscription.add(categoryIdSub);

        const quoteSub = this.quoteInfoService.quote$.subscribe(x => {
            this.quoteId = x.quoteId;
            this.productLineId = x.productLineId;
            this.modelId = x.modelId;
        });
        this.subscription.add(quoteSub);

        const showAddCustomOptionSub = this.addCustomOptionService.showAddCustomOption$.subscribe(x => {
            this.customOption = new SelectedOption();
            this.validPrice = true;
            this.enableSave = false;
        });
        this.subscription.add(showAddCustomOptionSub);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    closeAside() {
        this.addCustomOptionService.showAddCustomOption$.next(false);
    }

    getSelectedOptionCategories() {
        this.optionsService.getPartCategories()
            .subscribe(x => {
                let partCategories: PartCategory[] = x;
                if (partCategories && partCategories.length > 0) {
                    partCategories.forEach((pCat) => {
                        let cat: TextValuePair = new TextValuePair();
                        cat.value = (pCat.PartCategoryNumber < 10) ? '0' + pCat.PartCategoryNumber.toString() : pCat.PartCategoryNumber.toString();
                        cat.text = cat.value + ' - ' + pCat.PartCatDesc;
                        this.categories.push(cat);
                    });
                }
            });
    }

    saveCustom() {
        this.spinnerService.showLoadingSpinner.next(true);
        this.customOption.IsCustomOption = true;
        this.customOption.IsValidUnitPrice = true;
        this.customOption.UnitPriceOverride = null;
        this.customOption.UnitPrice = Number(this.customOption.UIUnitPrice);
        this.customOption.AdjustedTotalPrice = (this.customOption.Quantity * Number(this.customOption.UIUnitPrice));
        this.customOption.QuoteId = this.quoteId;
        this.customOption.HomeOptionsCategoryId = this.categoryId;
        this.customOption.OptionDesc = this.customOption.OptionDesc.toUpperCase();
        this.customOption.OptionNumber = this.customOption.OptionNumber.toString() + '9999';
        this.customOption.Visible = true;
        if (this.customOption.Note !== undefined && this.customOption.Note !== null) {
            if (this.customOption.Note.trim() === '') {
                this.customOption.Note = null;
            }
        }

        this.optionsService.markOptionChangedByFacility(this.customOption);

        let customList = new Array<SelectedOption>();
        customList.push(this.customOption);

        const saveSelectedOptionsSub = this.optionsService.saveSelectedOptions(customList, this.categoryId, this.modelId, 0, new Adjustment())
            .subscribe(
                (x => {
                    this.customOptions = x.filter(j => j.IsCustomOption === true);
                    this.addCustomOptionService.showAddCustomOption$.next(false);
                    this.spinnerService.showLoadingSpinner.next(false);
                    let toast: Toast = {
                        type: 'success',
                        title: 'Success',
                        body: 'Your custom option has been saved',
                        timeout: 2000
                    };
                    this.toasterService.pop(toast);
                    this.optionsService.customOptionsfromDB$.next(x.filter(j => j.IsCustomOption === true));
                }),
                (error => {
                    this.spinnerService.showLoadingSpinner.next(false);
                    this.httpResponseService.httpErrorResponse$.next(error);
                }),
                (() => { this.customOption = new SelectedOption(); })
        );
        this.subscription.add(saveSelectedOptionsSub);
    }

    validateUnitPrice() {
        this.enableSave = false;
        this.validPrice = (((Number(this.customOption.UIUnitPrice) >= -99999.99) && (Number(this.customOption.UIUnitPrice) <= 99999.99))
            || this.customOption.UIUnitPrice === undefined)
            ? true : false;
        this.customOption.IsCustomPrice = true;
        this.customOption.UnitPrice = Number(this.customOption.UIUnitPrice);
        this.enableSave = this.validPrice;
    }

    clearUnitPrice(item) {
        item.UIUnitPrice === '0.00' ? item.UIUnitPrice = null : null;
    }

    setTrailingZero() {
        this.customOption.UIUnitPrice = this.optionsService.setTrailingZero(this.customOption.UIUnitPrice);
    }

    get validQuantity(): boolean {
        if (this.customOption === undefined || this.customOption === null) { return true; }
        if (Number(this.customOption.UIUnitPrice) < 0 && this.customOption.Quantity > 1) { return false; }
        return true;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/add-custom-option/add-custom-option.component.ts